/**
 * Other handlers used by Slate plugins.
 *
 * @type {Array}
 */

const OTHER_HANDLERS = [
  'decorateNode',
  'renderAnnotation',
  'renderBlock',
  'renderDecoration',
  'renderDocument',
  'renderEditor',
  'renderInline',
  'renderMark',
]

/**
 * Export.
 *
 * @type {Array}
 */

export default OTHER_HANDLERS
